import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { scheduleScrollToPageTop } from "../utils/scrollToTop";

const ScrollToTop = () => {
  const { key, pathname, search } = useLocation();

  useEffect(() => {
    if (!window.history?.scrollRestoration) {
      return undefined;
    }

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    return scheduleScrollToPageTop();
  }, [key, pathname, search]);

  return null;
};

export default ScrollToTop;
